<template>
    <div class="index">
        <side-bar class="menu"></side-bar>
        <app-main ></app-main>
    </div>
</template>

<script>

    import Appmain from '../layout/Appmain.vue'
    import Sidebar from '../layout/Sidebar.vue'

    export default {
        data() {
            return {
                screenWidth: document.body.clientWidth
            }
        },
        components: {
            'side-bar':Sidebar,
            'app-main':Appmain
        },
        watch: {
            screenWidth (val) {
                this.screenWidth = val
                console.log(this.screenWidth);
                if (this.screenWidth > 769) {
                    this.isActive = true;
                } else {
                    this.isActive = false;
                }
            }
        }
    }
</script>

<style>


    @media screen and (max-width: 799px){



    }
    @media screen and (min-width: 799px){

    }

    .index{
        width: 100%;
    }
    .menu{
        float: left;
    }

</style>


// WEBPACK FOOTER //
// Content.vue?1febf28b